
document.addEventListener("DOMContentLoaded", () => {
  // Parallax on scroll
  const parallaxItems = document.querySelectorAll(".immersive-scene");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("visible");
      }
    });
  }, {
    threshold: 0.1
  });

  parallaxItems.forEach(item => {
    observer.observe(item);
    item.style.transition = "transform 0.8s ease-out, opacity 0.8s ease-out";
    item.style.opacity = 0;
    item.style.transform = "translateY(30px)";
  });

  // Cursor-based subtle rotation
  document.addEventListener("mousemove", (e) => {
    const x = (e.clientX / window.innerWidth - 0.5) * 10;
    const y = (e.clientY / window.innerHeight - 0.5) * 10;
    document.querySelectorAll(".immersive-scene").forEach(el => {
      el.style.transform = `rotateX(${y}deg) rotateY(${x}deg) scale(1.01)`;
    });
  });
});
